import { Dictionary } from 'frontcore/presentation/types'
import { getLanguage } from 'frontcore/i18n'

export const roundFloatFormatter = (value: number, isPercentage: boolean): string => {
  const roundedValue =  (Math.round((value + Number.EPSILON) * 100) / 100).toLocaleString()
  return isPercentage ? `${roundedValue} %` : roundedValue.toString()
}

const getSortString = (item: unknown, propertyName: string | undefined): string => {
  if (typeof item === 'string') {
    return item
  } else if (
    propertyName !== undefined &&
    typeof item === 'object' &&
    item !== null &&
    propertyName in item &&
    typeof (item as Dictionary<string>)[propertyName] === 'string'
  ) {
    return (item as Dictionary<string>)[propertyName] as string
  }
  throw new Error('[sortAlphabetically]: Invalid item provided to sort')
}

export const sortAlphabetically = (key?: string | undefined) => {
  const locale = getLanguage()
  return (lhs: unknown, rhs: unknown): number => {
    const lhsString = getSortString(lhs, key)
    const rhsString = getSortString(rhs, key)
    return lhsString.localeCompare(rhsString, locale, { sensitivity: 'base' })
  }
}
